import React, { Component } from 'react'
import {GoLocation} from 'react-icons/go'
import {BsFillTelephonePlusFill} from 'react-icons/bs'

export default class Contactme extends Component {
  render() {
    return (
        <section className="contact">
          <div className="kirishSoz">
            <h1>Contact me </h1>
          </div>
          <h1 className='title'>Have you any Qestion</h1>
          <p>i`m at your services</p>
          <ul className='network'>
            <li>
              <GoLocation />
              <b>My location</b>
              <p>Uzbekistan</p>
            </li>
            <li>
              <BsFillTelephonePlusFill />
              <b>call use on</b>
              <p>+998 88 820 12 88</p>
            </li>
          </ul>
          <h1 className='title'>pliss senda message me</h1>
          <p>i`m response message</p>
          <form className='contact_form' action="" method="get">
            <input placeholder='Name' id='name' className='name' type="text" />
            <input placeholder='@Email' id='email' className='email' type="email" />
            <input placeholder='Subject' id='subject' className='subject' type="text" />
            <textarea name="" id="" cols="30" rows="10"></textarea>
            <input className='submit' type="submit" value={'submit'}/>
          </form>
        </section>
    )
  }
}
